import fontLoadCallback from 'fontfaceonload'
// TODO: Allow this to pass an array of fonts to watch
export default function fontFlashPrevention() {
  fontLoadCallback('Material Icons', {
    success: function() {
      document.body.className += ' icons-loaded'
    }
  })
}


// WEBPACK FOOTER //
// ./lib/brave-placeholders/fontFlashPrevention.js